import { CurrentSocieteMereApplicationUserDetails } from './types';
import { useAuthenticatedCurrentUser } from '@eogile/agrements-common/src/security/CurrentUserContext';

export const useSocieteMereAuthenticatedCurrentUser = () => {
  return useAuthenticatedCurrentUser<CurrentSocieteMereApplicationUserDetails>();
};
